export default __webpack_public_path__ + "static/media/facebook.63f8d9cf.svg";